import React, { useState } from 'react';
import api from './http';
import './App.css';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await api.post('/admin/login', { username, password });
      if (res.data.success) {
        if (onLogin) onLogin();
        // Determine redirect target from ?next= param if present and safe
        const params = new URLSearchParams(window.location.search);
        const next = params.get('next');
        const safeNext = next && next.startsWith('/') ? next : '/admin';
        window.location.href = safeNext;
      } else {
        setError(res.data.message || 'Login failed');
      }
    } catch (err) {
      setError('Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-hero">
        <img src="/hero-portrait.jpg" alt="" className="admin-login-hero-img" />
        <div className="admin-login-hero-overlay" />
      </div>

      <div className="admin-login-panel">
        <div className="admin-login-brand">
          <span className="admin-login-brand-name">EVOLUTION</span>
          <span className="admin-login-brand-sub">Admin Portal</span>
        </div>

        <form className="admin-login-form" onSubmit={handleSubmit}>
          <div className="admin-login-field">
            <label htmlFor="admin-username">Username</label>
            <input
              id="admin-username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              autoComplete="username"
              autoCapitalize="none"
            />
          </div>
          <div className="admin-login-field">
            <label htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          {error && <div className="admin-login-error">{error}</div>}

          <button className="admin-login-submit" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
